module.exports = __webpack_public_path__ + "static/img/ico_uncertain@2x.4fd305c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/talents/ico_uncertain@2x.png
// module id = K/4u
// module chunks = 0